// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"360f6758","453":"e2bf0358"}[chunkId] + ".chunk.js";
};